/**
 * 经典金主题 — 图片资源映射
 * key 为语义化名称，组件通过 themeImg(key) 获取
 */
export default {
  // 通用
  banner: require('@/assets/banner.png'),
  copy: require('@/assets/copy.png'),
  payLogo: require('@/assets/payLogo.png'),
  payLogo2: require('@/assets/payLogo2.png'),

  // 1119 系列（DisplayLogic 步骤图标）
  success: require('@/assets/1119/success.png'),
  arrow: require('@/assets/1119/arrow.png'),
  submitDecor: require('@/assets/1119/submit.png'),
  tips: require('@/assets/1119/tips.png'),
  card: require('@/assets/1119/card.png'),
  cardMobile: require('@/assets/1119/card_m.png'),
  refresh: require('@/assets/1119/refresh.png'),
  refreshMobile: require('@/assets/1119/refresh_m.png'),
  account: require('@/assets/1119/account.png'),
  tipsContent: require('@/assets/1119/tipsContent.png'),

  // cardPay_GH 系列（弹窗 / 跳转逻辑）
  submit: require('@/assets/cardPay_GH/submit.png'),
  submitMobile: require('@/assets/cardPay_GH/submit_m.png'),
  close: require('@/assets/cardPay_GH/close.png'),
  edit: require('@/assets/cardPay_GH/edit.png'),
  header: require('@/assets/cardPay_GH/header.png'),
  headerMobile: require('@/assets/cardPay_GH/header_m.png'),
  transaction: require('@/assets/cardPay_GH/tansaction.png'),
  transactionMobile: require('@/assets/cardPay_GH/tansaction_m.png'),
  countdown: require('@/assets/cardPay_GH/countdown.png'),
  countdownMobile: require('@/assets/cardPay_GH/countdown_m.png'),
  wepay: require('@/assets/cardPay_GH/wepay.png'),
  wepayMobile: require('@/assets/cardPay_GH/wepay_m.png'),
  popupImg: require('@/assets/cardPay_GH/popupimg.png'),
  bgi: require('@/assets/cardPay_GH/bgi.png'),
  bgiMobile: require('@/assets/cardPay_GH/bgi_m.png'),

  // 警示 / 危险提示
  danger: require('@/assets/cardPay_NG/danger.png'),
  dangerMobile: require('@/assets/cardPay_NG/danger_m.png'),

  // SMS 验证
  smsClose: require('@/assets/1231/close.png'),
  sms: require('@/assets/1231/sms.png'),

  // 支付方式选中
  paymentSelected: require('@/assets/CI/true.png'),

  // 轮询 / 成功页（prokash 系列）
  pending: require('@/assets/prokash/pending.gif'),
  repaymentSuccess: require('@/assets/prokash/success.png'),
  selectArrow: require('@/assets/prokash/right@2x.png'),

  // LinkedPay
  express: require('@/assets/linkedpay/express.png'),
};
